import { documentNumberTranslations } from './document-number-i18n';
import { duplicationTranslations } from './duplication-i18n';
import { partnerMapTranslations } from './partner-map-i18n';
import { actionNeedTranslations } from './action-needs-i18n';
import { listViewTranslations } from './list-view-i18n';
import { pdfFieldCheckTranslations } from './pdf-field-check-i18n';
import { batchSelectionTranslations } from './batch-selection-i18n';
import { documentProgressTranslations } from './document-progress-i18n';
import { stockAdjustmentTranslations } from './stock-adjustment-i18n';
import { documentLockTranslations } from './document-lock-i18n';
import { portalRecoveryTranslations } from './portal-recovery-i18n';

import { priceGroupTranslations } from './price-group-i18n';
import { shippingTranslations } from '@erp/shared';
import { headerTranslations } from './header-i18n';
import { documentEntryTranslations } from './document-entry-i18n';
import { documentWorkspaceTranslations } from './document-workspace-i18n';
import { subdivisionTranslations } from './subdivision-i18n';
import { contactBriefingTranslations } from './contact-briefing-i18n';
import { internationalTranslations } from './international-i18n';
import { deliveryPlanningTranslations } from '@erp/shared';
import { introductionTranslations } from './introduction-i18n';
import { adminFr } from './admin-fr';
import { analyticsFr } from './analytics-fr';
import { dashboardFr } from './dashboard-i18n';
import { dmsFr } from './dms-fr';
import { partnersFr } from './partners-fr';
import { pdfDesignerFr } from './pdf-designer-fr';
import { procurementFr } from './procurement-fr';
import { settingsHubFr } from './settings-hub-fr';
import { telephonyFr } from './telephony-fr';
import { whatsAppFr } from './whatsapp-fr';
import { helpFr } from './help-fr';
import { feedbackFr } from './feedback-fr';
import { productSpecificationsFr } from './product-specifications-fr';
import { plmFr } from './plm-fr';
import { manufacturingFr } from './manufacturing-fr';
import { traceabilityFr } from './traceability-fr';
import { mrpFr } from './mrp-fr';
import { labelsFr } from './labels-fr';
import { changeControlFr } from './change-control-fr';
import { productDevelopmentDashboardFr } from './product-development-dashboard-fr';
import { searchFr } from './search-i18n';
import { vatValidationFr } from './vat-validation-i18n';
import { navigationFr } from './navigation-i18n';
import { dunningFr } from './dunning-i18n';
import { portalFr } from './portal-i18n';
import { productNewsFr } from './product-news-i18n';
import { newsletterFr } from './newsletter-i18n';
import { setupFr } from './setup-i18n';
import { importCenterFr } from './import-center-i18n';
import { bankingFr } from './banking-i18n';
import { translationGlossaryFr } from './translation-glossary-i18n';
import { salesAssistantFr } from './sales-assistant-i18n';
import { customerHeaderFr } from './customer-header-i18n';
import { featureAdminFr } from './feature-admin-i18n';

export const fr = {
  translation: {
    documentNumber: documentNumberTranslations.fr,
    duplication: duplicationTranslations.fr,
    partnerMap: partnerMapTranslations.fr,
    actionNeeds: actionNeedTranslations.fr,
    listViews: listViewTranslations.fr,
    pdfFieldCheck: pdfFieldCheckTranslations.fr,
    stockAdjustment: stockAdjustmentTranslations.fr,
    batchSelection: batchSelectionTranslations.fr,
    documentProgress: documentProgressTranslations.fr,
    documentLock: documentLockTranslations.fr,
    portalRecovery: portalRecoveryTranslations.fr,
    shipping: shippingTranslations.fr,
    priceGroups: priceGroupTranslations.fr,
    header: headerTranslations.fr,
    documentEntry: documentEntryTranslations.fr,
    documentWorkspace: documentWorkspaceTranslations.fr,
    ...contactBriefingTranslations.fr,
    international: internationalTranslations.fr,
    subdivision: subdivisionTranslations.fr,
    deliveryPlanning: deliveryPlanningTranslations.fr,
    introduction: introductionTranslations.fr,
    admin: { ...adminFr, dataHub: importCenterFr, features: featureAdminFr },
    analytics: analyticsFr,
    dms: dmsFr,
    portal: portalFr,
    productNews: productNewsFr,
    newsletter: newsletterFr,
    setup: setupFr,
    partners: partnersFr,
    pdfDesigner: pdfDesignerFr,
    procurement: procurementFr,
    settingsHub: settingsHubFr,
    telephony: telephonyFr,
    whatsapp: whatsAppFr,
    help: helpFr,
    feedback: feedbackFr,
    productSpecifications: productSpecificationsFr,
    plm: plmFr,
    manufacturing: manufacturingFr,
    traceability: traceabilityFr,
    mrp: mrpFr,
    labels: labelsFr,
    changeControl: changeControlFr,
    productDevelopmentDashboard: productDevelopmentDashboardFr,
    search: searchFr,
    vatValidation: vatValidationFr,
    dunning: dunningFr,
    banking: bankingFr,
    translationGlossary: translationGlossaryFr,
    paymentTerms: {
      netDays_one: '{{count}} jour net',
      netDays_other: '{{count}} jours nets',
      discountPreview: '{{due}}, escompte de {{percent}} % sous {{days}} jours',
      customLegacy: 'Anciennes conditions individuelles',
      search: 'Rechercher des conditions de paiement…',
      noResults: 'Aucune condition de paiement correspondante.',
      loadError: 'Impossible de charger les conditions de paiement.',
      warningCustom: 'Ces anciennes valeurs ne sont liées à aucune règle configurée.',
      warningInconsistent:
        'Les anciennes valeurs sont contradictoires. Sélectionnez des conditions valides.',
      advanced: 'Valeurs de paiement individuelles',
      customAgreement: 'Accord individuel',
      selectionHint:
        'Le délai de paiement et l’escompte sont repris automatiquement des conditions sélectionnées.',
      customHint:
        'Ces valeurs individuelles remplacent les conditions du catalogue. Une sélection ci-dessus les remplace.',
      customize: 'Définir un accord individuel',
      inconsistentValues:
        'Le délai d’escompte, l’escompte et l’échéance sont incompatibles. Vérifiez les valeurs ou sélectionnez des conditions de paiement.',
      savedValues:
        'Conditions enregistrées · {{due}} · {{percent}} % d’escompte sous {{days}} jours',
    },
    addressResolution: {
      automatic: 'Déterminée automatiquement',
      adoptRegion: 'Utiliser la région proposée {{region}}',
      importPlan: 'Régions prévues par le test confirmé (valeurs manuelles conservées)',
      status: {
        RESOLVED: 'Région déterminée sans ambiguïté.',
        INCOMPLETE: 'Saisissez un code postal complet à cinq chiffres.',
        UNSUPPORTED: 'L’attribution automatique de région n’est pas disponible pour ce pays.',
        NO_MATCH:
          'Aucune commune correspondante. Vérifiez l’adresse ou saisissez la région manuellement.',
        CONFLICT:
          'La commune et le code postal ne correspondent pas. Corrigez l’adresse ou choisissez une commune.',
        AMBIGUOUS:
          'Les résultats appartiennent à plusieurs régions. Choisissez la commune correspondante.',
        MISSING_REGION:
          'Les données administratives ne contiennent pas de région complète. Saisissez-la manuellement.',
        UNAVAILABLE:
          'La recherche de région est indisponible. Vous pouvez toujours enregistrer manuellement.',
      },
      backfill: {
        title: 'Compléter les régions vides des adresses françaises existantes',
        hint: 'Aperçu de 50 adresses au maximum. Sélectionnez et confirmez les compléments sans ambiguïté. Les fiches modifiées et les régions déjà renseignées sont ignorées. L’aperçu expire après 30 minutes.',
        partners: 'Vérifier les adresses principales',
        addresses: 'Vérifier les autres adresses',
        next: 'Vérifier le groupe suivant',
        empty: 'Aucune autre adresse française avec une région vide.',
        select: 'Sélectionner {{label}} pour complément',
        apply: 'Confirmer {{count}} compléments sélectionnés',
        result: '{{updated}} complétées ; {{skipped}} modifiées ou déjà complétées.',
        error: 'Le traitement a échoué. Créez un nouvel aperçu et vérifiez de nouveau.',
      },
      loading: 'Recherche de la commune et de la région…',
      errorFallback: 'La recherche est indisponible. Saisissez les informations manuellement.',
      noResults: 'Aucune commune correspondante. Saisissez-la manuellement.',
      useSuggestion: 'Utiliser {{value}}',
      choose: 'Choisir une commune',
      chooseCount: '{{count}} communes trouvées — choisissez',
      source: 'Source : {{source}}',
      help: 'Aide sur la recherche de commune',
    },
    salesAssistant: salesAssistantFr,
    customerHeader: customerHeaderFr,
    app: {
      name: 'ERP',
      tagline: 'ERP Web modulaire',
    },
    nav: {
      ...navigationFr,
      label: 'Navigation principale',
      openMenu: 'Ouvrir le menu',
      expandGroup: 'Développer {{name}}',
      collapseGroup: 'Réduire {{name}}',
      dashboard: 'Tableau de bord',
      partners: 'Partenaires commerciaux',
      partnerCustomers: 'Clients',
      partnerProspects: 'Prospects / leads',
      partnerSuppliers: 'Fournisseurs',
      partnerAll: 'Tous les contacts',
      products: 'Articles',
      productDevelopment: 'Développement produit',
      productDevelopmentOverview: 'Vue d’ensemble',
      recipes: 'Recettes et nomenclatures',
      batchScaling: 'Mise à l’échelle des lots',
      declarations: 'Déclarations',
      declarationCatalog: 'Référentiel de déclaration',
      analysisProfiles: 'Profils d’analyse',
      analysisParameters: 'Paramètres d’analyse',
      labels: 'Étiquettes',
      changeControl: 'Gestion des modifications',
      documents: 'Documents',
      dms: 'Archives documentaires',
      procurement: 'Achats',
      manufacturing: 'Production',
      productionOrders: 'Ordres de production',
      traceability: 'Traçabilité des lots',
      mrp: 'Planification des besoins matières',
      purchaseOrders: 'Commandes fournisseur',
      goodsReceipts: 'Réceptions de marchandises',
      vendorInvoices: 'Factures fournisseur',
      analytics: 'Analyses',
      datev: 'Exportation DATEV',
      intrastat: 'Intrastat',
      settings: 'Paramètres',
      profile: 'Mon profil',
      security: 'Sécurité',
      notifications: 'Notifications',
      company: 'Société',
      pdfDesigner: 'Modèles PDF',
      users: 'Utilisateurs',
      roles: 'Rôles et autorisations',
      securityLog: 'Journal de sécurité',
      admin: 'Administration',
      whatsapp: 'WhatsApp',
      whatsappConfig: 'Configuration WhatsApp',
    },
    console: {
      label: 'Administration',
      breadcrumb: "Fil d'Ariane",
      openMenu: "Ouvrir le menu d'administration",
      backToApp: 'Retour à la vue principale',
      groups: {
        overview: 'Système et présentation',
        access: 'Accès et sécurité',
        configuration: 'Configuration',
        communication: 'Communication',
      },
      items: {
        accounting: 'Plan comptable DATEV',
      },
    },
    theme: {
      label: 'Apparence',
      light: 'Clair',
      dark: 'Sombre',
      system: 'Système',
    },
    language: {
      label: 'Langue',
      search: 'Rechercher une langue',
      noResults: 'Aucune langue trouvée.',
      saveError: 'La langue n’a pas pu être enregistrée.',
      tr: 'Turc',
      fr: 'Français',
      es: 'Espagnol',
      de: 'Allemand',
      en: 'Anglais',
    },
    dashboard: {
      title: 'Tableau de bord',
      ...dashboardFr,
    },
    errorPage: {
      title: 'Erreur inattendue',
      description: "Cette vue n'a pas pu être chargée.",
      reload: 'Recharger la page',
    },
    systemStatus: {
      title: 'État du système',
      description: "Vérification en direct de l'état de préparation de l'API.",
      loading: 'Chargement de l’état…',
      error: "L'état du système n'a pas pu être chargé.",
      retry: 'Réessayez',
      api: 'API',
      database: 'Base de données',
      version: 'Version',
      uptime: 'Disponibilité',
      state: {
        ok: 'Opérationnel',
        degraded: 'Dégradé',
        up: 'Connecté',
        down: 'Déconnecté',
      },
      uptimeValue: '{{minutes}} min.',
    },
    common: {
      loading: 'Chargement …',
      create: 'Créer',
      saving: 'Enregistrement…',
      save: 'Enregistrer',
      confirm: 'Confirmer',
      select: 'Veuillez sélectionner',
      error: 'Une erreur inattendue est survenue.',
      cancel: 'Annuler',
      back: 'Retour',
      delete: 'Supprimer',
      edit: 'Modifier',
      close: 'Fermer',
      retry: 'Réessayer',
      previous: 'Précédent',
      next: 'Suivant',
      none: 'Aucun',
      pleaseSelect: 'Veuillez sélectionner',
      pagination: 'Pagination',
      paginationInfo: 'Page {{page}} sur {{totalPages}} · {{total}} enregistrements',
      copy: 'Copier',
      copied: 'Copié',
      actions: 'Actions',
      showDetails: 'Afficher les détails',
      hideDetails: 'Masquer les détails',
    },
    validation: {
      required: 'Obligatoire',
      email: 'Veuillez fournir une adresse e-mail valide.',
    },
    errors: {
      requestFailed: 'La demande a échoué',
      unexpectedTitle: 'Erreur inattendue',
      unexpectedMessage: "Une erreur inattendue s'est produite.",
      copyHint: '(cliquez pour copier)',
      copyId: "Copier l'ID",
      copied: "ID d'erreur {{id}} copié.",
    },
    documentPricing: {
      overrideRequired: 'Ce rôle ne peut pas modifier les prix ni les conditions financières.',
    },
    permissions: {
      customerPricingReadOnly:
        'Les groupes de prix, remises et conditions d’escompte sont en lecture seule pour ce rôle.',
      deniedTitle: 'Aucun accès',
      deniedDescription: "Cette vue nécessite l'autorisation {{permission}}.",
    },
    auth: {
      title: 'Se connecter',
      subtitle: "Connectez-vous avec vos informations d'identification.",
      email: 'E-mail',
      password: 'Mot de passe',
      tenantSlug: 'Locataire',
      tenantSlugHint: 'Nom abrégé du locataire, par ex. acmé.',
      submit: 'Se connecter',
      logout: 'Se déconnecter',
      checking: 'Séance de vérification…',
      invalidCredentials: "L'e-mail ou le mot de passe est incorrect.",
      accountLocked: 'Le compte est temporairement verrouillé. Veuillez réessayer plus tard.',
      tenantRequired:
        'Cette adresse e-mail existe dans plusieurs organisations. Veuillez indiquer l’organisation.',
      twoFactor: {
        title: 'Vérification à deux facteurs',
        description: "Saisissez le code à six chiffres de votre application d'authentification.",
        emailDescription: 'Saisissez le code à six chiffres envoyé à {{email}}.',
        useMethod: { TOTP: "Utiliser l'application", EMAIL: 'Utiliser le code e-mail' },
        resend: 'Renvoyer le code',
        resendIn: 'Nouvel envoi dans {{seconds}} s',
        backupDescription: "Saisissez l'un de vos codes de secours.",
        code: 'Code de vérification',
        backupCode: 'Code de sauvegarde',
        submit: 'Vérifier',
        invalid: 'Le code est invalide ou a expiré.',
        useBackupCode: 'Utiliser un code de secours',
        useAuthenticator: "Utiliser l'application d'authentification",
      },
    },
    customFields: {
      createTitle: 'Créer un champ personnalisé',
      editTitle: 'Modifier le champ personnalisé',
      dialogDescription:
        'Les champs personnalisés étendent les données client sans modification du code. La clé et le type de champ sont corrigés après la création.',
      key: '',
      keyHint: 'Nom technique, par ex. groupeclient.',
      type: 'Type de champ',
      label: 'Étiquette',
      labelEn: 'Étiquette (anglais)',
      group: 'Groupe',
      sortOrder: 'Ordre de tri',
      required: 'Obligatoire',
      showInList: 'Afficher dans la liste',
      filterable: 'filtrable',
      marketingSegmentationAllowed: 'Approuvé pour la segmentation des newsletters',
      options: 'Options',
      addOption: 'Ajouter une option',
      removeOption: "Supprimer l'option",
      noOptions: 'Aucune option définie pour le moment.',
      optionValue: 'Valeur',
      optionLabel: 'Étiquette',
      created: 'Champ personnalisé créé.',
      updated: 'Champ personnalisé mis à jour.',
      archived: 'Champ personnalisé archivé.',
      archive: 'Archives',
      archiveTitle: 'Archiver le champ personnalisé',
      archiveDescription:
        'Le champ "{{name}}" sera masqué. Les valeurs existantes sont conservées.',
      saveError: "Le champ personnalisé n'a pas pu être enregistré.",
      loadError: "Les champs personnalisés n'ont pas pu être chargés.",
      filters: {
        action: 'Champs personnalisés',
        title: 'Filtrer par champs personnalisés',
        description:
          'Les champs texte recherchent un contenu ; les autres utilisent une valeur exacte.',
        reset: 'Réinitialiser',
        clearField: 'Supprimer le filtre pour {{field}}',
      },
      weeklySchedule: {
        empty: 'Aucun créneau horaire renseigné.',
        hint: 'Choisissez les jours et les heures locales. Plusieurs créneaux sont possibles. La fin doit suivre le début le même jour.',
        invalid: 'Indiquez au moins un jour et des heures de début et de fin valides.',
        required: 'Au moins un créneau horaire complet est requis.',
      },
      types: {
        WEEKLY_SCHEDULE: 'Jours de semaine et horaires',
        TEXT: 'Texte',
        TEXTAREA: 'Texte multiligne',
        NUMBER: 'Numéro',
        DATE: 'Date',
        CHECKBOX: 'Case à cocher',
        SELECT: 'Sélectionner',
        MULTI_SELECT: 'Sélection multiple',
      },
    },
    customers: {
      title: 'Clients',
      subtitle: 'Données de base, conditions et historique des contacts de tous les clients.',
      searchPlaceholder: 'Rechercher nom, numéro, ville, numéro de TVA …',
      searchLabel: 'Rechercher des clients',
      columnsMenu: 'Colonnes',
      createTitle: 'Nouveau client',
      editTitle: 'Modifier le client',
      formDescription:
        'Les champs obligatoires sont marqués. Le numéro de client est attribué automatiquement.',
      created: 'Client créé.',
      updated: 'Client enregistré.',
      saveError: "Le client n'a pas pu être enregistré.",
      actions: {
        create: 'Nouveau client',
        export: 'Exporter',
        logCall: "Journal d'appel",
        createQuote: 'Créer un devis',
        backToList: 'Retour à la liste',
      },
      tabs: {
        master: 'Données de base et adresses',
        customFields: 'Champs personnalisés',
        history: 'Histoire',
        documents: 'Documents',
        whatsapp: 'WhatsApp',
      },
      sections: {
        masterData: 'Données de base',
        address: 'Adresse',
        tax: 'Fiscalité et identification',
        conditions: 'Conditions de paiement',
        customFields: 'Champs personnalisés',
      },
      detail: {
        since: 'Créé le {{date}}',
      },
      values: {
        days_one: '{{count}} jour',
        days_other: '{{count}} jours',
      },
      columns: {
        customerNumber: 'Numéro',
        displayName: 'Nom',
        status: 'Statut',
        industry: 'Industrie',
        email: 'E-mail',
        phone: 'Téléphone',
        city: 'Ville',
        countryCode: 'Pays',
        vatId: 'Numéro de TVA',
        ownerName: 'Propriétaire',
        tags: 'Balises',
      },
      fields: {
        type: 'Type de client',
        status: 'Statut',
        customerNumber: 'Numéro de client',
        customerNumberHint: 'Laisser vide pour une affectation automatique.',
        industry: 'Industrie',
        companyName: "Nom de l'entreprise",
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        email: 'E-mail',
        phone: 'Téléphone',
        website: 'Site Web',
        street: 'Rue',
        houseNumber: 'Numéro de maison',
        addressLine2: "Ligne d'adresse 2",
        postalCode: 'Code postal',
        city: 'Ville',
        region: 'Région',
        countryCode: 'Pays',
        vatId: 'Numéro de TVA',
        vatIdHint: 'Le format est validé, par ex. DE123456789.',
        vatIdStatus: 'Statut du numéro de TVA',
        taxNumber: 'Numéro fiscal',
        taxCategory: 'Catégorie de taxe',
        datevDebtorAccount: 'Compte débiteur DATEV',
        gln: 'GLN',
        eoriNumber: 'Numéro EORI',
        currency: 'Devise',
        documentLanguage: 'Langue du document',
        paymentTermsDays: 'Conditions de paiement (jours)',
        defaultDiscountPct: 'Remise',
        cashDiscountPct: 'Escompte',
        cashDiscountDays: "Période d'escompte (jours)",
        deliveryTerms: 'Conditions de livraison',
        creditLimit: 'Limite de crédit',
        priceGroup: 'Groupe de prix',
        minRemainingShelfLifeDays: 'Durée de conservation minimale restante (jours)',
        deliveryBlock: 'Blocage de livraison',
        dunningBlock: 'Blocage de relance',
        ownerName: 'Propriétaire',
        tags: 'Balises',
        tagsHint: 'Séparez les valeurs multiples par des virgules.',
      },
      types: {
        COMPANY: 'Société',
        PERSON: 'Personne privée',
      },
      statuses: {
        ACTIVE: 'Actif',
        PROSPECT: 'Perspective',
        BLOCKED: 'Bloqué',
        INACTIVE: 'Inactif',
      },
      vatIdStatuses: {
        UNCHECKED: 'Décoché',
        VALID: 'Valide',
        INVALID: 'Invalide',
        NOT_CHECKABLE: 'Non vérifiable',
        SERVICE_UNAVAILABLE: 'Service indisponible',
      },
      taxCategories: {
        DOMESTIC: 'National',
        EU_B2B: 'B2B UE',
        EU_B2C: 'B2C UE',
        THIRD_COUNTRY: 'Pays tiers',
        REVERSE_CHARGE_DOMESTIC: 'Charge au preneur (national)',
        TAX_EXEMPT: "Exonéré d'impôt",
      },
      industries: {
        RETAIL: 'Commerce de détail',
        WHOLESALE: 'Vente en gros',
        MANUFACTURING: 'Fabrication',
        GASTRONOMY: 'Gastronomie',
        LOGISTICS: 'Logistique',
        HEALTHCARE: 'Santé',
        PUBLIC_SECTOR: 'Secteur public',
        CONSTRUCTION: 'Construction',
        AGRICULTURE: 'Agriculture',
        SERVICES: 'Prestations',
        OTHER: 'Autre',
      },
      documentTypes: {
        QUOTE: 'Devis',
        ORDER: 'Commande',
        DELIVERY_NOTE: 'Bon de livraison',
        INVOICE: 'Facture',
        CREDIT_NOTE: 'Avoir',
        CANCELLATION: 'Annulation',
      },
      documentStatuses: {
        DRAFT: 'Brouillon',
        OPEN: 'Ouvert',
        CONFIRMED: 'Confirmé',
        PARTIALLY_DELIVERED: 'Partiellement livré',
        DELIVERED: 'Livré',
        POSTED: 'Comptabilisé',
        PAID: 'Payé',
        CANCELLED: 'Annulé',
      },
      filters: {
        status: 'Statut',
        industry: 'Industrie',
        tags: 'Balises',
        vatIdStatus: 'Numéro de TVA',
        reset: 'Réinitialiser les filtres',
      },
      states: {
        empty: "Aucun client pour l'instant.",
        emptyFiltered: 'Aucun client ne correspond à la sélection actuelle.',
        error: "La liste des clients n'a pas pu être chargée.",
        detailError: "Le client n'a pas pu être chargé.",
      },
      export: {
        csv: 'Télécharger le fichier CSV',
        xlsx: 'Télécharger Excel',
        success: 'Exportation créée.',
        error: "L'exportation a échoué.",
      },
      delete: {
        title: 'Supprimer le client',
        description: 'Le client "{{name}}" sera désactivé et masqué.',
        success: 'Client supprimé.',
        error: "Le client n'a pas pu être supprimé.",
      },
      addresses: {
        title: 'Adresses supplémentaires',
        add: 'Adresse',
        createTitle: 'Ajouter une adresse',
        editTitle: 'Modifier l’adresse',
        description: "Adresses de livraison et de facturation différentes de l'adresse principale.",
        type: "Type d'adresse",
        label: 'Étiquette',
        recipient: 'Destinataire',
        isDefault: 'Par défaut',
        contact: {
          title: 'Contact pour cette adresse',
          hint: 'Coordonnées facultatives propres à cette adresse. Aucun contact général n’est créé.',
          name: 'Nom',
          position: 'Fonction / poste',
          phone: 'Téléphone',
          mobile: 'Téléphone mobile',
          email: 'E-mail',
          invalidEmail: 'Veuillez saisir une adresse e-mail valide.',
        },
        deliveryTermsOverride: 'Conditions de livraison différentes',
        individualDeliveryTerms: 'Conditions de livraison individuelles',
        inheritedDeliveryTerms: 'Valeur client : {{value}}',
        deliveryTermsHint:
          'Sans exception, les conditions de livraison de la fiche client sont utilisées automatiquement.',
        confirmRemoveDeliveryTerms:
          'Le changement de type supprime la condition de livraison individuelle. Continuer ?',
        empty: 'Aucune adresse supplémentaire.',
        created: 'Adresse enregistrée.',
        updated: 'Adresse mise à jour.',
        deleted: 'Adresse supprimée.',
        delete: "Supprimer l'adresse",
        deleteTitle: "Supprimer l'adresse",
        deleteDescription: "L'adresse sera supprimée de la fiche client.",
        error: "L'adresse n'a pas pu être enregistrée.",
        loadError: "Les adresses n'ont pas pu être chargées.",
        types: {
          BILLING: 'Adresse de facturation',
          SHIPPING: 'Adresse de livraison',
          OTHER: 'Autre',
        },
      },
      contacts: {
        title: 'Contacts',
        add: 'Contacter',
        createTitle: 'Ajouter un contact',
        editTitle: 'Modifier le contact',
        description: 'Interlocuteurs pour devis, commandes et appels.',
        salutation: 'Salutation',
        title_label: 'Titre',
        position: 'Poste',
        department: 'Département',
        mobile: 'Mobile',
        isPrimary: 'Contact principal',
        responsibilities: 'Responsabilités',
        responsibilitiesHint: 'Séparez plusieurs responsabilités par des virgules.',
        optOutMarketing: 'Exclure des communications marketing',
        empty: "Aucun contact pour l'instant.",
        created: 'Contact enregistré.',
        updated: 'Contact mis à jour.',
        deleted: 'Contact supprimé.',
        delete: 'Supprimer le contact',
        deleteTitle: 'Supprimer le contact',
        deleteDescription: 'Le contact sera supprimé de la fiche client.',
        error: "Le contact n'a pas pu être enregistré.",
        loadError: "Les contacts n'ont pas pu être chargés.",
      },
      notes: {
        add: 'Ajouter une note',
        subject: 'Sujet',
        body: 'Remarque',
        created: 'Note enregistrée.',
        error: "La note n'a pas pu être enregistrée.",
      },
      calls: {
        createTitle: "Journal d'appel",
        description: "Documenter le résultat, la durée et le suivi de l'appel.",
        direction: 'Orientation',
        outcome: 'Résultat',
        subject: 'Sujet',
        contact: 'Contacter',
        occurredAt: 'Heure',
        durationSeconds: 'Durée (secondes)',
        notes: "Notes d'appel",
        created: 'Appel enregistré.',
        error: "L'appel n'a pas pu être enregistré.",
        directions: {
          INBOUND: 'Entrant',
          OUTBOUND: 'Sortant',
        },
        outcomes: {
          REACHED: 'Atteint',
          NOT_REACHED: 'Non atteint',
          CALLBACK: 'Rappel accepté',
          ORDER_PLACED: 'Commande passée',
          COMPLAINT: 'Plainte',
          NO_INTEREST: 'Aucun intérêt',
        },
      },
      quotes: {
        createTitle: 'Créer un devis',
        description: 'Crée un projet de devis en utilisant les conditions de ce client.',
        reference: 'Référence',
        validDays: 'Validité (jours)',
        submit: 'Créer un devis',
        created: 'Devis créé.',
        error: "Le devis n'a pas pu être créé.",
      },
      documents: {
        empty: "Aucun document pour l'instant.",
        error: "Les documents n'ont pas pu être chargés.",
      },
      activities: {
        empty: "Aucune activité pour l'instant.",
        error: "L'historique n'a pas pu être chargé.",
        types: {
          DOCUMENT: 'Documents',
          NOTE: 'Remarques',
          CALL: 'Appels',
        },
      },
      customFields: {
        title: 'Champs personnalisés dynamiques',
        subtitle: 'Les champs sont configurés ici et sont disponibles immédiatement.',
        empty: "Aucun champ personnalisé n'a encore été défini.",
        saved: 'Champs personnalisés enregistrés.',
      },
    },
    inventory: {
      expiringWidget: {
        title: "Avertissements d'expiration",
        description: 'Lots avec une durée de conservation restante de {{days}} jours ou moins.',
        empty: "Aucun lot n'expire bientôt.",
        error: "Les avertissements d'expiration n'ont pas pu être chargés.",
        entry: 'Lot {{batch}} · {{quantity}} · emplacement {{location}}',
        open: 'Ouvrir',
        openBatch: 'Lot ouvert {{batch}} dans le produit',
        openProducts: 'Aller aux produits',
        showAll: 'Afficher tous les produits concernés',
      },
    },
    products: {
      title: 'Articles',
      subtitle: 'Données de base, prix, conditionnements et stock de lots.',
      searchPlaceholder: "Numéro d'article, nom ou GTIN…",
      searchLabel: 'Rechercher des produits',
      createTitle: 'Créer un produit',
      editTitle: 'Modifier le produit',
      formDescription: "Toutes les valeurs s'appliquent au locataire actuel.",
      created: 'Produit créé.',
      updated: 'Produit enregistré.',
      saveError: "Le produit n'a pas pu être enregistré.",
      columnsMenu: 'Colonnes',
      decimals: {
        hint: 'Utilisez un point ou une virgule décimale : 47,45 et 47.45 sont égaux. 47, ou 47. est enregistré comme 47. N’utilisez pas de séparateur de milliers.',
        moneyError:
          'Saisissez un nombre valide avec au maximum 4 décimales ; le point et la virgule sont acceptés.',
        percentError:
          'Saisissez une valeur de 0 à 100 avec au maximum 6 décimales ; le point et la virgule sont acceptés.',
        quantityError:
          'Saisissez un nombre positif ou nul avec au maximum 6 décimales ; le point et la virgule sont acceptés.',
      },
      texts: {
        translatedName: 'Nom ({{language}})',
        translatedDescription: 'Description ({{language}})',
        languageLabel: 'Langue des textes de l’article',
        optionalHint:
          'Les traductions sont facultatives. Les textes allemands sont utilisés en l’absence de traduction.',
        validationSummary: 'Veuillez vérifier les champs signalés. Vos saisies sont conservées.',
        nameRequired: 'Veuillez saisir le nom allemand.',
        nameTooLong: 'Le nom ne doit pas dépasser 200 caractères.',
        descriptionTooLong: 'La description ne doit pas dépasser 4000 caractères.',
      },
      tabs: {
        master: 'Données de base et prix',
        priceTiers: 'Niveaux de prix',
        specifications: 'Spécifications',
        packagings: 'Emballages',
        batches: 'Lots et expiration',
        movements: 'Historique des stocks',
      },
      detail: {
        stockSummary: 'Stock {{stock}} {{unit}} · disponible {{available}} {{unit}}',
      },
      badges: {
        batchManaged: 'Gestion par lots',
        belowMinStock: 'Stock inférieur au minimum',
      },
      actions: {
        create: 'Créer un produit',
        export: 'Exporter',
        bulkPrice_one: 'Mettre à jour les prix ({{count}})',
        bulkPrice_other: 'Mettre à jour les prix ({{count}})',
        adjustStock: 'Ajuster le stock',
        backToList: 'Retour à la liste',
      },
      export: {
        csv: 'Télécharger le fichier CSV',
        xlsx: 'Télécharger Excel',
        success: 'Exportation créée.',
        error: "L'exportation a échoué.",
      },
      states: {
        empty: "Aucun produit pour l'instant.",
        emptyFiltered: 'Aucun produit ne correspond aux filtres actuels.',
        error: "Les produits n'ont pas pu être chargés.",
        detailError: "Le produit n'a pas pu être chargé.",
      },
      selection: {
        toggleAll: 'Sélectionnez tous les produits sur cette page',
        toggleRow: 'Sélectionnez {{name}}',
      },
      columns: {
        icon: 'Genre',
        articleNumber: 'Article n°.',
        name: 'Nom',
        productGroup: 'Groupe de produits',
        stock: 'Actions',
        available: 'Disponible',
        listPrice: 'Prix catalogue',
        purchasePrice: 'Coût',
        batches: 'Lots',
        status: 'Statut',
        tags: 'Balises',
      },
      batchBadge: {
        count_one: 'Lot {{count}}',
        count_other: 'Lots {{count}}',
        expiring_one: "Avertissement d'expiration {{count}}",
        expiring_other: "Avertissements d'expiration {{count}}",
      },
      filters: {
        criticalStock: 'Stock critique',
        expiring: "Avertissements d'expiration (< {{days}} jours)",
        activeOnly: 'Produits actifs uniquement',
        status: 'Statut',
        type: 'Type de produit',
        productGroup: 'Groupe de produits',
        batchManaged: 'Suivi des lots',
        batchManagedOnly: 'Gestion par lots uniquement',
        batchManagedNone: 'Sans suivi des lots',
        reset: 'Réinitialiser les filtres',
      },
      sections: {
        base: 'Données de base',
        prices: 'Tarifs & planning',
        logistics: 'Logistique et douanes',
        batches: 'Lots et expiration',
        customFields: 'Champs personnalisés',
      },
      fields: {
        articleNumber: "Numéro d'article",
        articleNumberHint: 'Laissez vide pour tirer le numéro suivant de la plage.',
        name: 'Nom',
        nameEn: 'Nom (EN)',
        description: 'Description',
        type: 'Type de produit',
        status: 'Statut',
        ean: 'GTIN/EAN',
        manufacturerNumber: 'Numéro du fabricant',
        productGroup: 'Groupe de produits',
        baseUnit: 'Unité de base',
        taxRateType: "Taux d'imposition",
        taxRatePct: "Taux d'imposition (%)",
        currency: 'Devise',
        listPrice: 'Prix de vente',
        purchasePrice: "Prix d'achat",
        minMarginPct: 'Marge minimale (%)',
        marginHint: 'Marge actuelle : {{value}}',
        weightNetKg: 'Poids net (kg)',
        weightGrossKg: 'Poids brut (kg)',
        commodityCode: 'Code marchandise',
        commodityCodeHint: 'Numéro du tarif douanier à 8, 10 ou 11 chiffres.',
        countryOfOrigin: "Pays d'origine",
        minStock: 'Stock minimum',
        reorderPoint: 'Point de commande',
        targetStock: 'Stock cible',
        leadTimeDays: 'Délai (jours)',
        isBatchManaged: 'Gestion par lots',
        isShelfLifeManaged: 'Durée de conservation gérée',
        shelfLifeDays: 'Durée de conservation (jours)',
        shelfLifeDaysHint: "Utilisé pour préremplir la date d'expiration des nouveaux lots.",
        minRemainingShelfLifeDays: 'Durée de conservation minimale restante (jours)',
        pickingStrategy: 'Stratégie de sélection',
        tags: 'Balises',
        tagsHint: 'Séparez les valeurs multiples par des virgules.',
      },
      statuses: {
        ARCHIVED: 'Archivé',
        ACTIVE: 'Actif',
        PHASE_OUT: 'Suppression progressive',
        DISCONTINUED: 'Discontinué',
        BLOCKED: 'Bloqué',
      },
      types: {
        STOCK: 'Article en stock',
        NON_STOCK: 'Article non stocké',
        SERVICE: 'Service',
        SET: 'Nomenclature',
        DEPOSIT: 'Dépôt',
      },
      taxRateTypes: {
        STANDARD: 'Tarif standard',
        REDUCED: 'Tarif réduit',
        ZERO: 'Taux zéro',
      },
      pickingStrategies: {
        FEFO: 'FEFO (premier expiré, premier sorti)',
        FIFO: 'FIFO (premier entré, premier sorti)',
        MANUAL: 'Sélection manuelle',
      },
      images: {
        title: 'Images du produit',
        gallery: "Galerie d'images",
        empty: "Aucune image n'a encore été ajoutée à ce produit.",
        loadError: "Les images du produit n'ont pas pu être chargées.",
        drop: 'Déposez les images ici ou sélectionnez des fichiers',
        detected: '{{count}} fichier(s) détecté(s)',
        remaining: '{{count}} emplacement(s) restant(s) · JPEG, PNG, WebP ou AVIF',
        choose: 'Choisir des fichiers',
        camera: "Utiliser l'appareil photo",
        invalidSelection:
          "Au moins un fichier est invalide ou le nombre maximal d'images serait dépassé.",
        removePending: 'Retirer {{name}} de la sélection',
        partialUploadError:
          "{{count}} image(s) n'ont pas pu être téléversée(s). Le produit est enregistré ; réessayez uniquement ces fichiers.",
        limits: "JPEG, PNG, WebP ou AVIF · 20 Mo maximum · jusqu'à {{count}} images",
        count: '{{current}} image(s) sur {{max}}',
        progress: 'Téléversement : {{progress}} %',
        uploadStates: {
          PENDING: 'En attente',
          UPLOADING: 'Téléversement : {{progress}} %',
          SUCCESS: 'Téléversée',
          FAILED: 'Échec — réessayer lors de l’enregistrement',
        },
        uploaded: '{{count}} image(s) téléversée(s).',
        uploadError: "Les images n'ont pas pu être téléversées.",
        emptyFile: 'Le fichier est vide.',
        fileTooLarge: 'Le fichier dépasse 20 Mo.',
        unsupportedFormat: 'Seuls JPEG, PNG, WebP et AVIF sont pris en charge.',
        tooMany: 'Un produit peut contenir au maximum {{count}} images.',
        selection: 'Sélection',
        select: 'Sélectionner {{title}}',
        primary: 'Image principale',
        makePrimary: 'Définir comme image principale',
        primarySet: 'Image principale modifiée.',
        fullscreen: 'Plein écran',
        original: "Voir l'original",
        replace: "Remplacer l'image",
        replaced: 'Image remplacée.',
        deleteTitle: "Supprimer l'image du produit ?",
        deleteDescription: '« {{name}} » ainsi que ses variantes seront définitivement supprimées.',
        deleted: 'Image supprimée.',
        deleteError: "L'image n'a pas pu être supprimée.",
        sorted: 'Ordre des images enregistré.',
        sortError: "L'ordre des images n'a pas pu être enregistré.",
        editTitle: "Modifier les détails de l'image",
        editDescription: "Le titre et le texte alternatif favorisent l'accessibilité.",
        imageTitle: "Titre de l'image",
        altText: 'Texte alternatif',
        altHint: "Décrivez brièvement et objectivement le contenu visible de l'image.",
        updated: "Détails de l'image enregistrés.",
        updateError: "L'image n'a pas pu être mise à jour.",
        retrySuccess: "Variantes de l'image régénérées.",
      },
      batchStatuses: {
        FREE: 'Gratuit',
        QUARANTINE: 'Quarantaine',
        BLOCKED: 'Bloqué',
        EXPIRED: 'Expiré',
        DEPLETED: 'Épuisé',
      },
      movementTypes: {
        GOODS_RECEIPT: 'Entrée de marchandises',
        GOODS_ISSUE: 'Sortie de marchandises',
        TRANSFER_IN: 'Transfert dans',
        TRANSFER_OUT: 'Transfert sortant',
        ADJUSTMENT: 'Ajustement',
        INVENTORY_COUNT: 'Inventaire',
        SCRAP: 'Ferraille',
        RETURN_IN: 'Retour client',
        RETURN_OUT: 'Retour fournisseur',
      },
      referenceTypes: {
        MANUAL: 'Manuel',
        ORDER: 'Commande',
        DELIVERY_NOTE: 'Bon de livraison',
        INVOICE: 'Facture',
        PURCHASE_ORDER: 'Bon de commande',
        INVENTORY: 'Inventaire',
        PRODUCTION: 'Production',
      },
      units: {
        PCE: 'pièces',
        KGM: 'kg',
        GRM: 'g',
        LTR: 'je',
        MLT: 'ml',
        MTR: 'm',
        MTQ: 'm³',
        MTK: 'm²',
        PA: 'paquet',
      },
      packagingUnits: {
        BX: 'Boîte',
        CT: 'Carton',
        PF: 'Palette',
        PK: 'Pack',
        TU: 'Bac',
        BG: 'Sac',
        CS: 'Affaire',
      },
      priceTiers: {
        add: 'Ajouter un niveau',
        remove: 'Supprimer le niveau',
        empty: "Aucun niveau de prix défini pour l'instant.",
        saved: 'Niveaux de prix enregistrés.',
        saveError: "Les niveaux de prix n'ont pas pu être enregistrés.",
        calculate: 'Appliquer la réduction',
        calculatorHint: 'La remise est appliquée sur le prix catalogue.',
        columns: {
          priceGroup: 'Groupe de prix',
          minQuantity: 'De la quantité',
          unitPrice: 'Prix unitaire',
          discountPct: 'Remise (%)',
          margin: 'Marge',
          validFrom: 'Valable à partir du',
          validTo: "Valable jusqu'au",
        },
      },
      packagings: {
        add: 'Ajouter un emballage',
        remove: "Retirer l'emballage",
        empty: "Aucun packaging défini pour l'instant.",
        description: 'Le facteur de conversion décrit la quantité en {{unit}} par emballage.',
        saved: 'Emballages enregistrés.',
        saveError: "Les emballages n'ont pas pu être sauvegardés.",
        fields: {
          code: 'Code',
          name: 'Nom',
          unitCode: "Type d'emballage",
          factor: 'Facteur de conversion',
          factorHint: 'Quantité en {{unit}} par emballage.',
          ean: "GTIN de l'emballage",
          weightGrossKg: 'Poids brut (kg)',
          lengthMm: 'Longueur (mm)',
          widthMm: 'Largeur (mm)',
          heightMm: 'Hauteur (mm)',
          minOrderQuantity: 'Quantité minimale de commande',
          orderStepQuantity: 'Incrément de commande',
          isSalesDefault: 'Ventes par défaut',
          isPurchaseDefault: 'Achat par défaut',
        },
      },
      batches: {
        create: 'Ajouter un lot',
        empty: "Aucun lot pour l'instant.",
        error: "Les lots n'ont pas pu être chargés.",
        notManaged: "Ce produit n'est pas géré par lots.",
        includeDepleted: 'Afficher les lots épuisés',
        totalRemaining: 'Stock total {{value}} {{unit}}',
        daysLeft_one: '{{count}} jour restant',
        daysLeft_other: '{{count}} jours restants',
        block: 'Bloquer',
        release: 'Sortie',
        blocked: 'Lot {{batch}} bloqué.',
        released: 'Lot {{batch}} libéré.',
        blockTitle: 'Lot de blocs',
        blockDescription: 'Le lot {{batch}} sera bloqué en raison de problèmes.',
        blockReason: 'Raison',
        releaseReason: 'Libéré après inspection',
        updateError: "Le lot n'a pas pu être mis à jour.",
        customFieldsEditTitle: 'Modifier les champs personnalisés du lot',
        customFieldsEditDescription: 'Données supplémentaires du lot {{batch}}.',
        customFieldsSaved: 'Champs personnalisés du lot enregistrés.',
        levels: {
          EXPIRED: 'Expiré',
          CRITICAL: 'Critique',
          WARNING: 'Avertissement',
          OK: 'Non critique',
        },
        columns: {
          batchNumber: 'Lot',
          bestBeforeDate: 'À consommer de préférence avant',
          remainingShelfLife: 'Durée de conservation restante',
          remaining: 'Quantité restante',
          storageLocation: 'Emplacement de stockage',
          status: 'Statut',
          actions: 'Actions',
        },
      },
      batchDialog: {
        title: 'Ajouter un lot',
        description: 'Entrée de marchandises pour {{name}}.',
        submit: 'Ajouter un lot',
        created: 'Lot {{batch}} ajouté.',
        error: "Le lot n'a pas pu être créé.",
        fields: {
          batchNumber: 'Numéro de lot',
          quantity: 'Quantité ({{unit}})',
          productionDate: 'Date de production',
          bestBeforeDate: 'Date de péremption',
          bestBeforeHint: "Suggéré à partir d'une durée de conservation de jours {{days}}.",
          storageLocation: 'Emplacement de stockage',
          warehouseCode: 'Entrepôt',
          supplierBatchNumber: 'Lot fournisseur',
          certificateRef: 'Certificat',
          countryOfOrigin: "Pays d'origine",
          unitCost: 'Coût unitaire',
          referenceType: 'Type de référence',
          notes: 'Remarques',
        },
      },
      adjustment: {
        title: 'Ajustement des stocks',
        description: '{{name}} · stock actuel {{stock}}',
        modeLabel: 'Type de publication',
        modes: {
          DELTA: "Quantité d'ajustement",
          COUNT: 'Stock compté',
        },
        submit: 'Message',
        success: 'Stock ajusté.',
        newStock: 'Nouveau stock : {{value}}',
        error: 'La publication a échoué.',
        fields: {
          quantity: "Quantité d'ajustement",
          quantityHint:
            'Les valeurs positives ajoutent du stock, les valeurs négatives le suppriment.',
          countedQuantity: 'Stock compté',
          countedQuantityHint:
            'La différence avec le stock de livres est comptabilisée automatiquement.',
          batch: 'Lot',
          warehouseCode: 'Entrepôt',
          reason: 'Raison',
          reasonHint: "Obligatoire, au moins caractères {{min}} (preuve d'audit).",
        },
      },
      movements: {
        description: 'Tous les mouvements de stock dans un ordre irréprochable.',
        empty: "Aucun mouvement signalé pour l'instant.",
        error: "L'historique des stocks n'a pas pu être chargé.",
        filterType: 'Type de mouvement',
        balanceAfter: 'Solde après : {{value}}',
        entry: '{{date}} · {{user}} · {{reference}}',
      },
      bulkPrice: {
        title: 'Mettre à jour les prix',
        description: 'La modification est appliquée aux produits sélectionnés {{count}}.',
        submit: 'Mettre à jour les prix',
        success: 'Produits {{updated}} mis à jour, {{skipped}} ignoré.',
        error: 'La mise à jour du prix a échoué.',
        targets: {
          LIST_PRICE: 'Prix de vente',
          PURCHASE_PRICE: "Prix d'achat",
        },
        modes: {
          PERCENT: 'Variation en pourcentage',
          ABSOLUTE: 'Ajouter le montant',
          SET: 'Fixer un prix fixe',
        },
        valueLabels: {
          PERCENT: 'Variation en pourcentage',
          ABSOLUTE: 'Modification en montant',
          SET: 'Nouveau prix',
        },
        fields: {
          target: 'Champ Prix',
          mode: 'Calcul',
          roundTo: 'Décimales',
          reason: 'Raison',
          reasonHint: "Stocké dans le journal d'audit.",
        },
      },
    },
    documents: {
      packaging: {
        baseUnitPriceColumn: 'Prix pièce / unité de base',
        baseUnitPriceLabel: 'Prix par {{unit}}',
        baseUnitPriceInvalid:
          'Saisissez un prix valide avec quatre décimales au maximum. Le prix du conditionnement calculé doit également respecter les limites autorisées.',
        baseUnitPrice: 'Prix par {{unit}} : {{price}}',
        label: 'Unité / conditionnement',
        conversion: '{{quantity}} {{packaging}} = {{baseQuantity}} {{baseUnit}}',
        historic: 'enregistré',
        loading: 'Chargement des conditionnements …',
        loadError: 'Impossible de charger les conditionnements.',
        pricing: 'Calcul du prix …',
        priceError:
          'Prix non confirmé. Vérifiez la quantité et le conditionnement, puis réessayez.',
        saveBlocked:
          'Chargez les conditionnements et terminez le calcul du prix avant d’enregistrer.',
        invalid: 'Saisissez une quantité valide.',
        minimum: 'La quantité minimale est de {{value}} dans l’unité sélectionnée.',
        step: 'La quantité doit être un multiple de {{value}} dans l’unité sélectionnée.',
      },
      legacyCustomFieldsNotice:
        'Les définitions historiques des champs personnalisés de ce document sont indisponibles. Ces champs ne sont pas réinterprétés. Veuillez utiliser le document original.',
      title: 'Documents',
      subtitle:
        'Devis, commandes, bons de livraison et factures tout au long de la chaîne documentaire.',
      tabs: {
        all: 'Tous',
      },
      types: {
        QUOTE: 'Devis',
        ORDER: 'Commande',
        DELIVERY_NOTE: 'Bon de livraison',
        INVOICE: 'Facture',
        CANCELLATION: "Facture d'annulation",
        CREDIT_NOTE: 'Avoir',
        PURCHASE_ORDER: 'Bon de commande',
      },
      statuses: {
        DRAFT: 'Brouillon',
        SENT: 'Envoyé',
        ACCEPTED: 'Accepté',
        REJECTED: 'Rejeté',
        CONFIRMED: 'Confirmé',
        IN_PROGRESS: 'En cours',
        PARTIALLY_PROCESSED: 'Partiellement traité',
        SHIPPED: 'Expédié',
        COMPLETED: 'Terminé',
        POSTED: 'Comptabilisé',
        CANCELLED: 'Annulé',
      },
      paymentStatuses: {
        OPEN: 'Ouvert',
        PARTIALLY_PAID: 'Partiellement payé',
        PAID: 'Payé',
        OVERDUE: 'En retard',
        WRITTEN_OFF: 'Radié',
      },
      taxStrategies: {
        REGULAR: 'Régime fiscal standard',
        REVERSE_CHARGE: 'Autoliquidation',
        INTRA_COMMUNITY: 'Fourniture intracommunautaire',
        EXPORT_NON_EU: 'Exportation (hors UE)',
      },
      taxDetermination: {
        title: 'Détermination fiscale explicable',
        loading: 'Vérification de la recommandation fiscale…',
        unavailable: 'La recommandation fiscale est actuellement indisponible',
        selectCustomer:
          'Sélectionnez un client, un mode de livraison et des lignes pour obtenir une recommandation.',
        suggestion: 'Recommandation',
        applySuggestion: 'Appliquer la recommandation',
        reasonsTitle: 'Motifs de la décision',
        actionsTitle: 'Contrôles et justificatifs en attente',
        noActions: 'Aucun contrôle en attente détecté.',
        overrideReason: 'Motif de la décision différente',
        overridePlaceholder: 'Documentez le motif commercial examiné (10 caractères minimum)',
        overrideForbidden: 'Seuls les rôles autorisés peuvent déroger à la recommandation.',
        disclaimer:
          'Cette recommandation facilite la vérification du document, mais ne constitue pas un conseil fiscal ou juridique. Les cas particuliers, comme les opérations en chaîne ou triangulaires, exigent un examen spécialisé.',
        deliveryMode: 'Mode de livraison',
        deliveryModes: {
          SHIPMENT: 'Expédition',
          PICKUP: 'Enlèvement',
          UNKNOWN: 'Pas encore décidé',
        },
        assessments: {
          ELIGIBLE: 'Conditions détectées',
          NOT_ELIGIBLE: 'Conditions non remplies',
          REVIEW_REQUIRED: 'Examen requis',
        },
        reasons: {
          CROSS_BORDER_EU_DESTINATION:
            'La destination se trouve dans un autre État membre de l’UE.',
          DOMESTIC_DESTINATION: 'La destination se trouve dans le pays du vendeur.',
          DESTINATION_NOT_EU: 'La destination se trouve hors de l’UE.',
          DESTINATION_MISSING: 'La destination réelle n’a pas été confirmée.',
          SELLER_NOT_EU:
            'Le vendeur ne se trouvait pas dans un État membre de l’UE à la date du document.',
          CUSTOMER_IS_COMPANY: 'Le client est enregistré comme entreprise.',
          CUSTOMER_NOT_COMPANY: 'Le client n’est pas enregistré comme entreprise.',
          CUSTOMER_CONFIGURED_EU_B2B: 'Le client est configuré comme entreprise B2B de l’UE.',
          CUSTOMER_NOT_CONFIGURED_EU_B2B: 'La catégorie fiscale du client n’est pas B2B UE.',
          VAT_ID_VALID_AND_CURRENT:
            'Le numéro de TVA actuel dispose d’un justificatif VIES valide.',
          VAT_ID_MISSING: 'Le client n’a pas de numéro de TVA.',
          VAT_ID_INVALID: 'Le dernier contrôle du numéro de TVA n’était pas valide.',
          VAT_ID_COUNTRY_MISMATCH:
            'Le préfixe du numéro de TVA ne correspond pas à la destination.',
          VAT_VALIDATION_MISSING: 'Aucun contrôle VIES n’est disponible.',
          VAT_VALIDATION_STALE:
            'Le justificatif VIES est périmé ou utilise une ancienne correspondance.',
          VAT_VALIDATION_UNAVAILABLE:
            'VIES était indisponible ; cela ne constitue pas un justificatif valide.',
          VAT_ID_CHANGED_SINCE_DOCUMENT_SNAPSHOT:
            'Le numéro de TVA a changé depuis le dernier instantané du document.',
          BILLING_AND_DESTINATION_DIFFER:
            'Le pays de facturation diffère du pays de destination réel.',
          GOODS_SUPPLY: 'Les lignes ont été identifiées comme une livraison de biens.',
          SERVICE_SUPPLY_REVIEW:
            'Les services exigent un examen distinct du lieu de prestation et de la fiscalité.',
          MIXED_SUPPLY_REVIEW: 'Les biens et services sont mélangés et exigent un examen distinct.',
          SUPPLY_TYPE_UNKNOWN: 'La nature de la prestation n’est pas encore claire.',
          PICKUP_REVIEW:
            'Le mouvement transfrontalier exige un justificatif distinct en cas d’enlèvement.',
          DELIVERY_MODE_UNKNOWN: 'Le mode de livraison n’a pas encore été décidé.',
          TRANSPORT_EVIDENCE_AVAILABLE:
            'Un justificatif d’expédition ou douanier lié est disponible.',
          TRANSPORT_EVIDENCE_REQUIRED:
            'Un justificatif de transport est encore requis pour l’exonération.',
          EXISTING_EXPORT_CONFIGURATION:
            'La configuration d’exportation du client a été prise en compte.',
          EXISTING_REVERSE_CHARGE_CONFIGURATION:
            'La configuration d’autoliquidation existante a été prise en compte.',
          MASTER_FACTS_INCOMPLETE:
            'Des informations actuelles de base ou d’adresse manquent pour l’évaluation fiscale.',
          SPECIAL_CASE_REVIEW: 'Ce cas n’est pas automatisé et exige un examen spécialisé.',
        },
        actions: {
          VERIFY_VAT_ID: 'Effectuez un contrôle VIES actuel du numéro de TVA.',
          CONFIRM_DESTINATION: 'Confirmez la destination réelle.',
          COLLECT_TRANSPORT_EVIDENCE:
            'Liez un bon de livraison ou un justificatif fiable d’expédition ou de douane.',
          REVIEW_SUPPLY_TYPE: 'Vérifiez la classification comme bien ou service.',
          REVIEW_PICKUP_OR_SPECIAL_CASE:
            'Faites examiner l’enlèvement ou le cas particulier par un spécialiste.',
          COMPLETE_MASTER_FACTS:
            'Vérifiez et complétez les informations de base ou d’adresse indiquées.',
          PROVIDE_OVERRIDE_REASON: 'Expliquez la décision fiscale différente.',
        },
      },
      paymentMethods: {
        INVOICE: 'Facture (acompte)',
        PREPAYMENT: 'Prépaiement',
        CASH: 'Espèces',
      },
      languages: {
        tr: 'Turc',
        es: 'Espagnol',
        de: 'Allemand',
        en: 'Anglais',
        fr: 'Français',
      },
      languageFallback:
        'Aucun modèle intégré n’est disponible pour cette langue. L’allemand est utilisé sans modèle du tenant.',
      columns: {
        number: 'Document n°',
        type: 'Type',
        customer: 'Client',
        documentDate: 'Date du document',
        dueDate: 'À payer',
        status: 'Statut',
        grossTotal: 'Brut',
      },
      filters: {
        search: 'Rechercher des documents',
        searchPlaceholder: 'Numéro de document, référence ou client…',
        status: 'Statut',
        allStatuses: 'Tous les statuts',
        dateFrom: 'Date du document : du',
        dateTo: 'Date du document : au',
        payment: {
          ALL: 'Tous',
          OPEN: 'Ouvert',
          OVERDUE: 'En retard',
          PAID: 'Payé',
        },
      },
      actions: {
        create: 'Nouveau document',
        lock: 'Publier un document',
        sendEmail: 'Envoyer par e-mail',
        convertTo: {
          QUOTE: 'Convertir en devis',
          ORDER: 'Convertir en commande',
          DELIVERY_NOTE: 'Créer un bon de livraison',
          INVOICE: 'Créer une facture',
          CANCELLATION: 'Annuler',
          CREDIT_NOTE: 'Créer un avoir',
          PURCHASE_ORDER: 'Créer un bon de commande',
        },
      },
      states: {
        empty: "Aucun document pour l'instant.",
        pagination: 'Page {{page}} de {{totalPages}} · Documents {{total}}',
      },
      editor: {
        back: 'Retour à la liste',
        newTitle: 'Nouveau document',
        newSubtitle: 'Choisissez un client, ajoutez des éléments de campagne et enregistrez.',
        type: 'Type de document',
        headSection: 'En-tête du document',
        itemsSection: 'Lignes',
        textsSection: 'Textes',
        customFieldsSection: 'Champs personnalisés',
        customFieldsInvalid: 'vérifier le champ {{count}}',
        customFieldsInvalid_other: 'vérifier les champs {{count}}',
        addCustomField: 'Ajouter un champ personnalisé',
        addCustomFieldHint: 'Recherchez un champ de document ou filtrez la liste par catégorie.',
        removeCustomField: 'Retirer {{field}} du document',
        searchCustomFields: 'Rechercher des champs personnalisés…',
        customFieldCategory: 'Catégorie de champ personnalisé',
        allCustomFieldCategories: 'Toutes les catégories',
        uncategorizedFields: 'Sans catégorie',
        noDocumentCustomFields: 'Aucun champ personnalisé configuré pour ce type de document.',
        noCustomFieldsSelected: 'Aucun champ personnalisé facultatif sélectionné.',
        noCustomFieldsAvailable: 'Aucun autre champ personnalisé correspondant.',
        itemCustomFieldColumns: 'Colonnes personnalisées',
        customFieldsToast: 'Erreur de champ personnalisé : {{field}} — {{reason}} [ID : {{id}}]',
        customFieldsMore: "Un champ supplémentaire n'est pas valide également.",
        customFieldsMore_other: "{{count}} d'autres champs sont également invalides.",
        customerPlaceholder: 'Rechercher un client…',
        noCustomers: 'Aucun client trouvé.',
        incomplete:
          'Veuillez indiquer le client, le destinataire et au moins un élément de campagne.',
        created: 'Document créé.',
        saved: 'Document enregistré.',
        partialQuantities: 'Choisir des quantités partielles',
        conversionQuantitiesHint:
          'Sans sélection, toutes les quantités restantes sont reprises. Pour une reprise partielle, 0 ou un champ vide ignore la ligne. Les reprises existantes sont vérifiées lors de la création.',
        conversionQuantityInvalid: 'Saisissez au moins une quantité positive valide.',
        converted: 'Document de suivi créé.',
        convertFailed: 'La conversion vers {{type}} a échoué',
        locked: 'Document comptabilisé.',
        customerLockedTitle: '🚨 Le client est bloqué pour les ventes',
        customerLockedReason: 'Raison : {{reason}}',
        customerLockedHint:
          'Aucun document ne peut être créé pour ce client. Veuillez contacter la comptabilité.',
        customerLockedOverride:
          "Une libération n'est possible qu'avec le mode de paiement par prépaiement ou en espèces.",
        customerLockedSwitchToPrepayment: 'Passer au prépaiement',
      },
      deliveryTerms: {
        replaceManualConfirmation:
          'Remplacer les conditions saisies manuellement par celles de la nouvelle adresse ?',
        reset: 'Rétablir la valeur par défaut',
        sources: {
          CUSTOMER_DEFAULT: 'Source : fiche client',
          SHIPPING_ADDRESS: 'Source : adresse de livraison',
          MANUAL: 'Source : saisie manuelle',
          NONE: 'Aucune condition de livraison',
        },
      },
      quoteValidity: {
        automaticHint:
          'Automatique : {{days}} jours à compter de la date du document. Vous pouvez modifier ou effacer la date.',
        manualHint: 'Date de validité du devis. Modifiez-la ou laissez-la vide si nécessaire.',
        loading: 'Chargement de la validité par défaut…',
        loadError:
          'La validité par défaut n’a pas pu être chargée. Réessayez ou saisissez la date manuellement.',
      },
      fields: {
        customer: 'Client',
        recipient: 'Destinataire',
        documentDate: 'Date du document',
        validUntil: 'Valable jusqu’au',
        reference: 'Votre référence',
        language: 'Langue du document',
        currency: 'Devise',
        taxStrategy: 'Détermination de la taxe',
        paymentMethod: 'Mode de paiement',
        paymentTermsDays: 'Conditions de paiement (jours)',
        cashDiscountPct: "% d'escompte",
        cashDiscountDays: "Jours d'escompte",
        discountPct: '% de remise globale',
        shippingAmount: 'Expédition',
        shippingAddress: 'Adresse de livraison',
        noShippingAddress: 'Aucune adresse de livraison',
        searchShippingAddress: 'Rechercher un libellé, destinataire ou une ville',
        noMatchingShippingAddress: 'Aucune adresse de livraison correspondante.',
        unnamedShippingAddress: 'Adresse de livraison sans détails',
        deliveryTerms: 'Conditions de livraison',
        headerText: "Texte d'en-tête",
        footerText: 'Texte de pied de page',
        internalNote: 'Note interne',
      },
      items: {
        position: 'Objet',
        article: 'Article',
        articlePlaceholder: 'Rechercher un article…',
        noArticles: 'Aucun article trouvé.',
        text: 'Texte libre',
        quantity: 'Quantité',
        unit: 'Unité',
        unitPrice: 'Prix unitaire',
        discount: '% de remise',
        taxRate: '% TVA',
        lineNet: 'Net',
        remove: 'Supprimer la ligne',
        addArticle: "Ligne d'article",
        addText: 'Ligne de texte',
        batch: 'Lot',
        stock: 'Actions',
        selectBatch: 'Sélectionner un lot',
      },
      totals: {
        title: 'Calcul',
        itemsNet: 'Éléments de campagne nets',
        discount: 'Remise globale {{pct}}',
        shipping: 'Expédition',
        net: 'Montant net',
        tax: 'TVA {{pct}} sur {{base}}',
        gross: 'Montant total',
        cashDiscount:
          'Payez dans les jours {{days}} : escompte {{pct}} ({{amount}}) – payable {{payable}}.',
      },
      batchPicker: {
        title: 'Sélection par lots',
        description: 'Proposition de « {{product}} » basée sur la stratégie de picking choisie.',
        strategy: 'Stratégie',
        bestBefore: 'À consommer de préférence avant',
        apply: 'Appliquer',
        empty: 'Aucun lot disponible trouvé.',
        shortfall: "Manque d'unités {{quantity}}.",
        levels: {
          EXPIRED: 'Expiré',
          CRITICAL: 'Critique',
          WARNING: 'Avertissement',
          OK: 'Non critique',
          UNKNOWN: 'Pas de date de péremption',
        },
      },
      preview: {
        title: 'Aperçu PDF',
        refresh: "Actualiser l'aperçu",
        download: 'Télécharger le PDF',
        toggle: "Activer/désactiver l'aperçu",
        stale: "L'aperçu affiche le dernier état enregistré.",
      },
      email: {
        title: 'Envoyer le document',
        description: 'Envoyer le document {{number}} avec le PDF en pièce jointe.',
        to: 'Destinataire',
        subject: 'Sujet',
        body: 'Messages',
        submit: 'Envoyer de manière contraignante',
        success: 'Document envoyé.',
        failed: "L'envoi a échoué.",
      },
      delete: {
        title: 'Supprimer le document',
        description:
          'Le brouillon {{number}} sera supprimé. Cette action ne peut pas être annulée.',
        success: 'Document supprimé.',
      },
    },
    users: {
      title: 'Gestion des utilisateurs',
      subtitle: 'Comptes, rôles et statut au sein de ce locataire.',
      create: 'Ajouter un utilisateur',
      searchPlaceholder: 'Rechercher un nom ou une adresse e-mail',
      error: "Les utilisateurs n'ont pas pu être chargés.",
      columns: {
        name: 'Nom',
        email: 'E-mail',
        role: 'Rôle',
        status: 'Statut',
        twoFactor: '2FA',
        lastLogin: 'Dernière connexion',
      },
      status: {
        active: 'Actif',
        inactive: 'Désactivé',
        locked: 'Verrouillé',
      },
      twoFactor: {
        on: 'Activé',
        off: 'Désactivé',
      },
      filters: {
        role: 'Filtrer par rôle',
        allRoles: 'Tous les rôles',
      },
      empty: {
        title: 'Aucun utilisateur trouvé',
        description: 'Ajustez la recherche ou créez un nouveau compte.',
      },
      actions: {
        label: 'Actions',
        edit: 'Modifier',
        unlock: 'Déverrouiller',
        resetPassword: 'Réinitialiser le mot de passe',
        resetTwoFactor: 'Réinitialiser 2FA',
      },
      fields: {
        email: 'E-mail',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        phone: 'Téléphone',
        locale: 'Langue',
        role: 'Rôle',
        isActive: 'Compte actif',
        selfRoleHint: 'Vous ne pouvez pas modifier votre propre rôle.',
      },
      sheet: {
        createTitle: 'Ajouter un utilisateur',
        createDescription: 'Le compte reçoit un mot de passe initial à usage unique.',
        editTitle: "Modifier l'utilisateur",
        editDescription: 'Ajustez les données de base, le rôle et le statut du compte.',
        passwordHint:
          "Le mot de passe initial est affiché une fois après l'enregistrement et doit être modifié lors de la première connexion.",
      },
      credentials: {
        title: 'Mot de passe initial',
        description: 'Remettez le relais à {{email}} une fois – il ne sera plus affiché.',
        hint: 'Le compte doit changer ce mot de passe lors de la première connexion.',
      },
      toast: {
        created: 'Utilisateur créé.',
        updated: 'Utilisateur enregistré.',
        unlocked: 'Compte déverrouillé.',
        twoFactorReset: "Réinitialisation de l'authentification à deux facteurs.",
      },
    },
    roles: {
      title: 'Rôles et autorisations',
      subtitle:
        "Matrice d'autorisations par rôle ; les modifications s’appliqueront lors de la prochaine connexion.",
      list: 'Rôles',
      create: 'Ajouter un rôle',
      error: "Les rôles n'ont pas pu être chargés.",
      ownerHint:
        'Le rôle de propriétaire détient toujours toutes les autorisations et ne peut pas être modifié.',
      permissionCount: 'Autorisations {{count}} sélectionnées',
      fields: {
        name: 'Nom',
        description: 'Description',
      },
      matrix: {
        resource: 'Zone',
        toggleRow: 'Toutes les autorisations pour {{resource}}',
      },
      resources: {
        FEATURES: 'Fonctions et modules',
        CUSTOMERS: 'Clients',
        PARTNER_RISK: 'Risque client et blocages',
        PRODUCTS: 'Articles',
        BATCHES: 'Lots & stock',
        DOCUMENTS: 'Documents',
        DOCUMENT_CUSTOMER_HEADERS: 'Données client dans les en-têtes',
        DMS: 'Gestion documentaire',
        ACCOUNTING: 'Comptabilité',
        ANALYTICS: 'Rapports',
        SETTINGS: 'Paramètres',
        USERS: 'Utilisateurs',
        TELEPHONY: 'Téléphonie et IA',
        ANALYSIS: "Profils d'analyse et nutritionnels",
        MANUFACTURING: 'Production',
        TRACEABILITY: 'Traçabilité des lots',
        MRP: 'Planification des besoins matières',
        LABEL_MANAGEMENT: 'Gestion des étiquettes',
        CUSTOM_FIELDS: 'Champs personnalisés dynamiques',
        INTRODUCTION: 'Mise en service',
        SETUP: 'Configuration du tenant',
        BACKUPS: 'Sauvegardes et restauration',
      },
      actions: {
        CREATE: 'Créer',
        READ: 'Lire',
        UPDATE: 'Mise à jour',
        DELETE: 'Supprimer',
        EXPORT: 'Exporter',
        APPROVE: 'Approuver',
        RELEASE: "Libérer l'ordre de fabrication",
        RESERVE: 'Réserver les matières',
        CONSUME: 'Comptabiliser les matières',
        COMPLETE: 'Déclarer la fin de production',
        SIMULATE: 'Simuler un rappel',
        BLOCK: 'Bloquer les lots',
        REVIEW: 'Contrôler',
        MANAGE: 'Gérer',
        ARCHIVE: 'Archiver',
        ADMIN: 'Administrer',
        USE: 'Passer des appels',
        VIEW: 'Afficher le risque',
        SET_LOCK: 'Appliquer le verrouillage',
        OVERRIDE_LOCK: 'Libérer le verrouillage',
        VIEW_OWN_LOGS: 'Propres appels',
        VIEW_ALL_LOGS: 'Tous les appels',
        VIEW_AI_SUMMARY: "Afficher l'analyse de l'IA",
        EDIT_AI_SUMMARY: "Modifier l'analyse IA",
        MANAGE_SETTINGS: 'Gérer les paramètres',
        VIEW_COSTS: 'Voir les coûts',
        RUN: 'Exécuter la planification',
        CONFIGURE: 'Configurer',
        CONVERT_PURCHASE: 'Créer un brouillon d’achat',
        CONVERT_PRODUCTION: 'Créer un brouillon de production',
        IMPORT: 'Effectuer un import en masse',
        ROLLBACK: 'Restaurer une version',
        MANAGE_FIELDS: 'Gérer les champs',
        MANAGE_GROUPS: 'Gérer les catégories',
        READ_CONFIDENTIAL: 'Lire les champs confidentiels',
        WRITE_CONFIDENTIAL: 'Modifier les champs confidentiels',
        VIEW_AUDIT: 'Voir l’historique des modifications',
        CREATE_SETTINGS: 'Créer une sauvegarde des paramètres',
        CREATE_MASTER_DATA: 'Créer une sauvegarde des données de base',
        CREATE_FULL: 'Créer une sauvegarde complète',
        DOWNLOAD: 'Télécharger la sauvegarde',
        RESTORE: 'Restaurer la sauvegarde',
        RESTORE_DRY_RUN: 'Simulation de restauration',
        VIEW_DEPLOYMENT: 'Voir les sauvegardes de déploiement',
        DELETE_DETAILS: 'Supprimer les détails client',
        EDIT_PRICES: 'Modifier les prix et remises',
        CANCEL: 'Annuler des documents',
      },
      delete: {
        title: 'Supprimer le rôle',
        description: 'Le rôle « {{name}} » sera supprimé définitivement.',
      },
      toast: {
        created: 'Rôle créé.',
        updated: 'Rôle enregistré.',
        deleted: 'Rôle supprimé.',
      },
    },
    profile: {
      title: 'Mon profil',
      subtitle: 'Données personnelles et préférence de langue.',
      account: 'Compte',
      emailChangeHint:
        "Une nouvelle adresse exige votre mot de passe actuel et désactive la 2FA par e-mail jusqu'à sa confirmation.",
      role: 'Rôle',
      tenant: 'Locataire',
      saved: 'Profil enregistré.',
    },
    security: {
      title: 'Sécurité',
      subtitle: 'Mot de passe, deuxième facteur et sessions actives.',
      password: {
        title: 'Changer le mot de passe',
        description:
          'Au moins 12 caractères avec majuscules et minuscules, un chiffre et un symbole.',
        current: 'Mot de passe actuel',
        new: 'Nouveau mot de passe',
        confirm: 'Confirmer le nouveau mot de passe',
        mismatch: 'Les mots de passe ne correspondent pas.',
        submit: 'Changer le mot de passe',
        changed: 'Mot de passe modifié.',
        show: 'Afficher le mot de passe',
        hide: 'Masquer le mot de passe',
        strengthLabel: 'Force du mot de passe',
        strength: {
          '0': 'Très faible',
          '1': 'Faible',
          '2': 'Foire',
          '3': 'Fort',
          '4': 'Très fort',
        },
        rules: {
          length: 'Au moins 12 caractères',
          uppercase: 'Une lettre majuscule',
          lowercase: 'Une lettre minuscule',
          digit: 'Un chiffre',
          special: 'Un symbole',
        },
      },
      forceChange: {
        title: 'Changement de mot de passe requis',
        description:
          'Votre compte a été créé avec un mot de passe initial. Veuillez choisir votre propre mot de passe maintenant.',
      },
      twoFactor: {
        title: 'Authentification à deux facteurs',
        description: "Protection supplémentaire via une application d'authentification (TOTP).",
        active: 'Activé',
        inactive: 'Désactivé',
        enable: 'Activer',
        disable: 'Désactiver',
        enableTitle: "Configurer l'authentification à deux facteurs",
        disableTitle: "Désactiver l'authentification à deux facteurs",
        disableDescription: 'Votre mot de passe et un code actuel sont requis pour confirmer.',
        intro:
          "Vous avez besoin d'une application d'authentification telle que 1Password, Aegis ou Google Authenticator.",
        start: 'Démarrer la configuration',
        steps: {
          scan: 'Étape 1 sur 3 : démarrez la configuration.',
          verify: 'Étape 2 sur 3 : scannez le code QR et saisissez le code.',
          codes: 'Étape 3 sur 3 : stocker les codes de sauvegarde.',
        },
        qrAlt: "Code QR pour configurer l'application d'authentification",
        enterCode: "Saisissez le code depuis l'application",
        code: 'Code de vérification',
        backupHint:
          'Ces codes remplacent le deuxième facteur si vous perdez votre appareil. Chaque code fonctionne une fois.',
        downloadCodes: 'Télécharger les codes de sauvegarde',
        enabled: 'Authentification à deux facteurs activée.',
        disabled: 'Authentification à deux facteurs désactivée.',
        authenticator: "Application d'authentification (TOTP)",
        makePrimary: 'Définir par défaut',
      },
      emailTwoFactor: {
        title: 'Activer le code e-mail',
        disableTitle: 'Désactiver le code e-mail',
        method: 'Code e-mail',
        description: 'Confirmez votre mot de passe, puis saisissez le code reçu par e-mail.',
        disableDescription:
          'Saisissez votre mot de passe et un code d’authentification ou de secours actuel.',
        secondFactor: 'Code d’authentification ou de secours',
        sentTo: 'Un code de sécurité a été envoyé à {{email}}.',
        send: 'Envoyer le code',
        confirm: 'Activer',
        enabled: 'La 2FA par e-mail est activée.',
        disabled: 'La 2FA par e-mail est désactivée.',
        independenceWarning:
          "Une application d'authentification est généralement plus indépendante et sûre que l'e-mail, surtout si les deux comptes sont utilisés sur le même appareil.",
      },
      twoFactorPolicy: {
        title: 'Politique 2FA du locataire',
        description: 'Contrôler les méthodes autorisées et les obligations du locataire.',
        error: "La politique de sécurité n'a pas pu être chargée.",
        methods: { TOTP: "Autoriser l'application", EMAIL: 'Autoriser le code e-mail' },
        required: 'Exiger la double authentification pour tous les utilisateurs',
        emailEnabled: 'Activer la 2FA par e-mail pour ce locataire',
        privilegedTotp: 'Exiger TOTP pour les rôles privilégiés',
        requiredRoles: 'Rôles soumis à la 2FA',
        roles: { OWNER: 'Propriétaire', ADMIN: 'Administrateur' },
        validity: 'Validité du code e-mail (minutes)',
        cooldown: 'Délai avant nouvel envoi (secondes)',
      },
      sessions: {
        title: 'Sessions actives',
        description: 'Appareils actuellement connectés avec ce compte.',
        empty: 'Aucune session active.',
        error: "Les sessions n'ont pas pu être chargées.",
        current: 'Cette séance',
        unknownDevice: 'Périphérique inconnu',
        revoke: 'Révoquer',
        revokeOthers: 'Révoquer toutes les autres sessions',
        revoked: 'Session révoquée.',
        revokedOthers: 'Toutes les autres sessions furent révoquées.',
      },
    },
    securityLog: {
      title: 'Journal de sécurité',
      subtitle: 'Connexions, modifications des autorisations et événements liés à la sécurité.',
      searchPlaceholder: 'Rechercher une adresse e-mail ou une adresse IP',
      filterEvent: 'Événement de filtre',
      allEvents: 'Tous les événements',
      empty: 'Aucune entrée pour les filtres sélectionnés.',
      error: "Le journal n'a pas pu être chargé.",
      columns: {
        timestamp: 'Horodatage',
        event: 'Événement',
        user: 'Utilisateur',
        ip: 'Adresse IP',
      },
      events: {
        LOGIN_SUCCESS: 'Connexion réussie',
        LOGIN_FAILED: 'Échec de la connexion',
        LOGOUT: 'Déconnexion',
        TWO_FACTOR_ENABLED: '2FA activé',
        TWO_FACTOR_DISABLED: '2FA désactivé',
        TWO_FACTOR_FAILED: '2FA a échoué',
        TWO_FACTOR_METHOD_CHANGED: 'Méthode 2FA modifiée',
        TWO_FACTOR_RESET: '2FA réinitialisée',
        EMAIL_CHANGED: 'Adresse e-mail modifiée',
        PASSWORD_CHANGED: 'Mot de passe modifié',
        PASSWORD_RESET: 'Réinitialisation du mot de passe',
        ACCOUNT_LOCKED: 'Compte verrouillé',
        ACCOUNT_UNLOCKED: 'Compte débloqué',
        ROLE_UPDATED: 'Rôle modifié',
        PERMISSIONS_MODIFIED: 'Autorisations modifiées',
        SESSION_REVOKED: 'Session révoquée',
        USER_CREATED: 'Utilisateur créé',
        USER_UPDATED: 'Utilisateur mis à jour',
      },
    },
    notifications: {
      title: 'Notifications',
      bell: 'Ouvrir les notifications',
      bellWithCount: '{{count}} notifications non lues',
      unread: 'Non lu',
      open: 'Ouvrir',
      markAllRead: 'Marquer tout comme lu',
      manage: 'Gérer les notifications',
      error: "Les notifications n'ont pas pu être chargées.",
      tabs: {
        all: 'Tous',
        unread: 'Non lu',
        critical: 'Critique',
      },
      empty: {
        title: 'Aucune notification',
        description: 'De nouveaux événements apparaissent ici en temps réel.',
      },
      categories: {
        STOCK_LOW: 'Niveau de réapprovisionnement',
        BATCH_EXPIRING: "Avertissement d'expiration",
        ORDER_CREATED: 'Nouvelle commande',
        INVOICE_OVERDUE: 'Facture en souffrance',
        TASK_ASSIGNED: 'Suivi',
        SYSTEM: 'Système',
      },
    },
    notificationSettings: {
      title: 'Notifications',
      subtitle: 'Décidez quels événements vous atteignent et où.',
      matrixTitle: 'Canaux de diffusion',
      matrixDescription:
        "La cloche signale instantanément les événements dans l'application, les e-mails vous parviennent également ailleurs.",
      error: "Les paramètres n'ont pas pu être chargés.",
      autoSave: 'Les modifications sont enregistrées immédiatement.',
      saved: 'Paramètre enregistré.',
      columns: {
        event: 'Événement',
        inApp: "Cloche intégrée à l'application",
        email: 'E-mail instantané',
      },
      descriptions: {
        STOCK_LOW: "Le stock d'un article atteint le niveau de réapprovisionnement.",
        BATCH_EXPIRING: 'Un lot expire dans les 30 jours suivants.',
        ORDER_CREATED: 'Une nouvelle commande est arrivée ou a été confirmée.',
        INVOICE_OVERDUE: "Une facture est ouverte au-delà de sa date d'échéance.",
        TASK_ASSIGNED: "Une note d'appel avec une suite vous a été attribuée.",
        SYSTEM: 'Événements de sécurité et système de ce locataire.',
      },
    },
    company: {
      title: 'Société',
      subtitle: 'Données de base, coordonnées bancaires et valeurs par défaut des documents.',
      error: "Les données de l'entreprise n'ont pas pu être chargées.",
      saved: "Données de l'entreprise enregistrées.",
      invalid: 'Veuillez examiner les champs en surbrillance.',
      sections: {
        identity: 'Société',
        identityHint: "Ces détails apparaissent dans l'en-tête et le pied de page du document.",
        tax: 'Fiscalité et banque',
        taxHint:
          'Données obligatoires selon § 14 UStG ainsi que le compte bancaire pour les factures.',
        layout: 'Mise en page du document',
        layoutHint: "Le logo et la couleur d'accent apparaissent sur chaque PDF généré.",
        documents: 'Valeurs par défaut du document',
        documentsHint: 'Préréglages pour les nouveaux devis et factures.',
      },
      fields: {
        companyName: "Nom de l'entreprise",
        legalForm: 'Forme juridique',
        ownerName: 'Propriétaire / directeur général',
        street: 'Rue et numéro',
        zip: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        phone: 'Téléphone',
        email: 'E-mail',
        website: 'Site Web',
        vatId: 'Numéro de TVA',
        taxNumber: 'Numéro fiscal',
        commercialRegister: 'Registre du commerce',
        commercialRegisterHint: 'par ex. HRB 12345, Amtsgericht Stuttgart',
        bankName: 'Banque',
        iban: 'IBAN',
        bic: 'BIC',
        primaryColor: 'Couleur primaire',
        invoiceDueDays: 'Délai de paiement en jours',
        quoteValidityDays: 'Validité du devis en jours',
        defaultEmailSender: "Adresse de l'expéditeur des documents",
        defaultEmailSenderHint: "Utilisé comme adresse de réponse lors de l'envoi de documents.",
      },
      legalForms: {
        EINZELUNTERNEHMEN: 'Entreprise individuelle',
        FREIBERUFLER: 'Indépendant',
        EK: 'e. K.',
        GBR: 'GbR',
        OHG: 'OHG',
        KG: 'KG',
        GMBH: 'SARL',
        GMBH_CO_KG: 'GmbH & Co.KG',
        UG: 'UG (responsabilité limitée)',
        AG: 'AG',
        SE: 'SE',
        EG: 'par exemple',
        LTD: 'Ltd.',
        GESMBH: 'GesmbH (Autriche)',
        AG_CH: 'AG (Suisse)',
        SONSTIGE: 'Autre',
      },
      logo: {
        empty: 'Pas de logo',
        preview: 'Aperçu du logo',
        select: 'Choisir le logo',
        remove: 'Supprimer le logo',
        hint: "PNG, JPEG ou SVG jusqu'à {{size}} Ko.",
        invalidType: 'Les formats autorisés sont PNG, JPEG et SVG.',
        tooLarge: 'Le fichier dépasse {{size}} Ko.',
      },
      color: {
        custom: 'Choisissez une couleur personnalisée',
        previewTitle: 'Facture RE-2026-00001',
        previewHint: 'En-tête du document et règles du tableau',
      },
    },
    accounting: {
      periods: {
        lastMonth: 'Le mois dernier',
        currentMonth: 'Mois en cours',
        q1: 'T1',
        q2: 'T2',
        q3: 'T3',
        q4: 'T4',
        currentYear: 'Année en cours',
        custom: 'Plage personnalisée',
        from: 'De',
        to: 'À',
      },
      months: {
        '1': 'janvier',
        '2': 'Février',
        '3': 'Mars',
        '4': 'avril',
        '5': 'Mai',
        '6': 'juin',
        '7': 'juillet',
        '8': 'Août',
        '9': 'septembre',
        '10': 'octobre',
        '11': 'novembre',
        '12': 'décembre',
      },
      federalStates: {
        '01': 'Schleswig-Holstein',
        '02': 'Hambourg',
        '03': 'Basse-Saxe',
        '04': 'Brême',
        '05': 'Rhénanie du Nord-Westphalie',
        '06': 'Hesse',
        '07': 'Rhénanie-Palatinat',
        '08': 'Bade-Wurtemberg',
        '09': 'Bavière',
        '10': 'Sarre',
        '11': 'Berlin',
        '12': 'Brandebourg',
        '13': 'Mecklembourg-Poméranie occidentale',
        '14': 'Saxe',
        '15': 'Saxe-Anhalt',
        '16': 'Thuringe',
      },
      natureOfTransaction: {
        '11': 'Achat/vente ferme',
        '12': 'Marchandises sur approbation ou essai',
        '21': 'Retour de marchandises',
        '22': 'Remplacement des marchandises retournées',
        '23': 'Remplacement des marchandises non retournées',
        '31': "Livraison dans le cadre des programmes d'aide",
        '41': 'Traitement, retour attendu',
        '51': 'Retour après traitement',
        '91': 'Location, prêt ou location sur 24 mois',
        '99': 'Autres opérations',
      },
      modeOfTransport: {
        '1': 'Transport maritime',
        '2': 'Transport ferroviaire',
        '3': 'Transport routier',
        '4': 'Transport aérien',
        '5': 'Envoi postal',
        '7': 'Installations fixes de transport',
        '8': 'Voie navigable',
        '9': 'Propre propulsion',
      },
      datev: {
        title: 'Exportation DATEV',
        subtitle: 'Lot d’écritures EXTF à transmettre au conseiller fiscal.',
        openSettings: 'Configuration',
        periodSection: 'Sélection de période et de document',
        reconciliation: 'Rapprochement : débit {{debit}} · crédit {{credit}}',
        tabs: {
          export: 'Exporter',
          history: "Historique d'exportation",
        },
        filters: {
          includeCancellations: "Inclure les factures d'annulation et les notes de crédit",
          includeAlreadyExported: 'Inclure les documents déjà exportés (exécution répétée)',
        },
        kpi: {
          records: 'Écritures comptables',
          documents: 'Documents',
          net: 'Volume net',
          gross: 'Volume brut',
        },
        columns: {
          date: 'Date du document',
          number: 'Document n°',
          customer: 'Client',
          account: 'Compte',
          contraAccount: 'Compte de contrepartie',
          buKey: 'Clé de taxe',
          net: 'Net',
          tax: 'TVA',
          gross: 'Brut',
          debitCredit: 'D/C',
          state: 'Statut',
        },
        state: {
          locked: 'Comptabilisé',
          open: 'Ouvert',
        },
        states: {
          empty: 'Aucun document exportable dans la période sélectionnée.',
        },
        validation: {
          clean: "Tous les documents de l'époque sont prêts à être exportés.",
          invalidRange: 'La date de début ne doit pas être postérieure à la date de fin.',
          openCustomer: 'Client ouvert',
          openDocument: 'Ouvrir le document {{number}}',
        },
        issues: {
          DEBTOR_ACCOUNT_MISSING_one: 'Document {{count}} sans compte débiteur.',
          DEBTOR_ACCOUNT_MISSING_other: 'Documents {{count}} sans compte débiteur.',
          REVENUE_ACCOUNT_MISSING_one: 'Document {{count}} sans compte de revenus mappé.',
          REVENUE_ACCOUNT_MISSING_other: 'Documents {{count}} sans compte de revenus mappé.',
          VAT_ID_MISSING_one: '{{count}} fourniture UE détaxée sans numéro de TVA du client.',
          VAT_ID_MISSING_other:
            '{{count}} fournitures européennes détaxées sans numéro de TVA du client.',
          DOCUMENT_NOT_LOCKED_one:
            "Le document {{count}} n'est pas encore validé et le sera à l'export.",
          DOCUMENT_NOT_LOCKED_other:
            "Les documents {{count}} ne sont pas encore validés et le seront à l'export.",
          DOCUMENT_ALREADY_EXPORTED_one: 'Le document {{count}} a déjà été remis.',
          DOCUMENT_ALREADY_EXPORTED_other: 'Les documents {{count}} ont déjà été remis.',
          SETTINGS_INCOMPLETE_one:
            'Le numéro de consultant et le numéro de client sont manquants dans la configuration.',
          SETTINGS_INCOMPLETE_other:
            'Le numéro de consultant et le numéro de client sont manquants dans la configuration.',
          AMOUNT_ZERO_one: 'Document {{count}} sans aucune ligne portant montant.',
          AMOUNT_ZERO_other: 'Documents {{count}} sans ligne portant le montant.',
        },
        export: {
          action: 'Exporter le lot d’écritures (.csv)',
          success: 'Lot d’écritures créé et téléchargé.',
        },
        history: {
          exportedAt: 'Exporté à',
          period: 'Période',
          filename: 'Fichier',
          records: 'Dossiers / documents',
          volume: 'Volume brut',
          checksum: 'Somme de contrôle',
          download: 'Télécharger à nouveau',
          repeat: 'Répéter',
          empty: "Aucun lot d’écritures n'a encore été exporté.",
          hint: "La somme de contrôle prouve que le fichier régénéré correspond à l'exécution archivée.",
        },
      },
      settings: {
        title: 'Configuration comptable',
        subtitle: 'Plan comptable, données de base DATEV et valeurs Intrastat par défaut.',
        chartSection: 'Plan comptable et données de base DATEV',
        mappingSection: 'Comptes de revenus par dossier fiscal',
        intrastatSection: 'Valeurs Intrastat par défaut',
        saved: 'Paramètres enregistrés.',
        charts: {
          SKR03: 'Basé sur un processus ; comptes de revenus compris entre 8 000 et 8 999.',
          SKR04: 'Basé sur le bilan ; comptes de revenus compris entre 4 000 et 4 999.',
        },
        fields: {
          consultantNumber: 'Numéro du consultant',
          clientNumber: 'Numéro de client',
          fiscalYearStart: "Début de l'exercice",
          accountNumberLength: 'Longueur du numéro de compte',
          debtorAccountRangeStart: 'Début de la plage de débiteurs',
          dictationKey: 'Touche de dictée',
          reportingVatId: 'Numéro de TVA du déclarant',
          federalState: 'Etat fédéral',
          natureOfTransaction: 'Nature par défaut de la transaction',
          modeOfTransport: 'Mode de transport par défaut',
        },
        mapping: {
          case: 'Dossier fiscal',
          account: 'Compte de revenus',
          buKey: 'Clé de taxe',
          accountFor: 'Compte de revenus pour {{case}}',
          buKeyFor: 'Clé fiscale pour {{case}}',
          automatic: 'Automatique',
        },
        revenueCases: {
          DOMESTIC_STANDARD: { label: 'National 19 %', hint: 'Tarif standard en Allemagne.' },
          DOMESTIC_REDUCED: { label: 'National 7 %', hint: 'Tarif réduit en Allemagne.' },
          DOMESTIC_EXEMPT: {
            label: 'Exonération nationale',
            hint: "Chiffre d'affaires intérieur détaxé.",
          },
          INTRA_COMMUNITY: {
            label: 'UE détaxé',
            hint: 'Livraison intracommunautaire, art. 4 non. 1b UStG.',
          },
          EXPORT_NON_EU: {
            label: 'Exportation hors UE',
            hint: "Approvisionnement à l'exportation, sec. 4 non. 1a UStG.",
          },
          REVERSE_CHARGE: {
            label: 'Charge au preneur',
            hint: 'Le destinataire est redevable de la TVA, art. 13b UStG.',
          },
        },
        debtors: {
          action: 'Attribuer des comptes débiteurs',
          assigned_one: 'Compte débiteur {{count}} attribué.',
          assigned_other: 'Comptes débiteurs {{count}} attribués.',
        },
      },
      intrastat: {
        title: 'Déclaration Intrastat',
        subtitle: "Expéditions vers d'autres États membres de l'UE par mois de référence.",
        periodSection: 'Période de référence',
        fields: {
          year: 'Année de déclaration',
          month: 'Mois de référence',
          direction: 'Flux',
        },
        directions: {
          DISPATCH: 'Expédition',
          ARRIVAL: 'Arrivée',
        },
        kpi: {
          value: 'Montant facturé',
          weight: 'Masse nette',
          positions: 'Articles déclarés',
        },
        columns: {
          commodityCode: 'Code marchandise (CN8)',
          destination: 'Destination',
          origin: "Pays d'origine",
          nature: 'Nature de la transaction',
          transport: 'Mode de transport',
          weight: 'Masse nette',
          invoiced: 'Montant facturé',
          statistical: 'Valeur statistique',
          partnerVatId: 'Numéro de TVA du partenaire',
        },
        issueFields: {
          commodityCode: 'Code marchandise manquant ou non 8 chiffres',
          countryOfOrigin: "Pays d'origine manquant",
          netWeight: 'Poids net manquant',
          destinationCountry: 'Pays de destination manquant',
        },
        readiness: {
          clean: 'Tous les éléments déclarables sont complets.',
          blocked_one: 'Le produit {{count}} bloque la déclaration.',
          blocked_other: 'Les produits {{count}} bloquent la déclaration.',
          openProduct: 'Ouvrir l’article',
        },
        states: {
          empty: 'Aucune expédition déclarable pour ce mois de référence.',
        },
        export: {
          csv: 'Liste de contrôle (.csv)',
          xml: 'INSTAT/XML pour IDEV',
          success: 'Fichier de déclaration créé et téléchargé.',
        },
      },
    },
  },
} as const;
